import React, { Component } from 'react';
import _ from 'lodash';
import cIf from 'classnames';

export class FormContainerView extends Component {
    render() {
        return (
            <div className="row">
                <div className="col-xs-12">
                    {this.props.cartFormCtls}
                    {this.props.orderFormCtls}
                    {this.props.ticketFormsCtls}

                    {this.props.errorsMessages}
                    <div className="btn-toolbar pull-right">
                        <button type="button" className="btn btn-default" onClick={this.props.onCancel}>{this.props.cancelButtonTitle}</button>
                        <button type="button" className="btn btn-primary" onClick={this.props.onSubmit}>{this.props.submitButtonTitle}</button>
                    </div>
                </div>
            </div>
        );
    }
}

export class FormChildrenView extends Component {
    render() {
        let ticketDescCtl = null;
        if (this.props.ticketDescription)
            ticketDescCtl = <li style={{verticalAlign:"top"}}>
                <h3 style={{marginTop:"5px"}}>{this.props.ticketDescription}</h3>
            </li>;
            
        return (
            <div className="form">
                <h2>{this.props.formName}</h2>
                <ul className="list-inline">
                    {ticketDescCtl}
                    {this.props.buttons}
                </ul>
                <p>{this.props.formDescription}</p> 
                <br/>
                {this.props.children}
            </div>
        );
    }
}

export class FormGroupWrapperView extends Component {
    render() {
        // TODO: Utiliser l<outil classNames ici
        var validationState;
        var helpBlocks = [];

        if(this.props.showValidationErrors) {
            validationState = this.props.validationErrors.length > 0;

            _.each(this.props.validationErrors, (err) => {
                var errorMessage = this.props.validator.translate(err.type);
                helpBlocks.push(<div key={err.type} className="help-block">{errorMessage}</div>);
            });
        }

        if(this.props.helpText.length > 0)
            helpBlocks.push(<div key="help" className="help-block">{this.props.helpText}</div>);

        return (
            <div title={this.props.example} className={cIf("form-group", { "has-error": validationState, "hidden": this.props.isVisibled == false })}>
                <label className="control-label" style={{marginRight:"5px"}}>{this.props.label}</label>
                {this.props.children}
                {helpBlocks}
            </div>
        );
    }
}

export class FormFieldListView extends Component {
    render() {
        return (
            <div>
                {this.props.children}
            </div>
        );
    }
}
